<template>
  <div id="app">
    <router-view
      v-if="$route.name == 'login' || $route.name == 'screen'"
      :class="{ vague: showProgress }"
    />
    <div v-else style="height: 100%" :class="{ vague: showProgress }">
      <div class="layout">
        <div class="mainLeft">
          <ele-menu :menuStatus="menuStatus" />
        </div>
        <div class="mainRight">
          <ele-head @controlMenu="controlMenu" />
          <!-- <title-bar/> -->
          <div v-if="isRouterAlive">
            <ele-tab v-if="$route.name!=='censusBusiness'">
              <template>
                <layout/>
              </template>
            </ele-tab>
            <router-view v-else/>
          </div>
        </div>
        <div class="clearfix" />
      </div>
    </div>
    <show-mongolia v-if="showProgress" />
  </div>
</template>

<script>
import bus from '@/bus';
import eleHead from '@/components/eleHead';
import eleMenu from '@/components/eleMenu';
import showMongolia from '@/components/showMongolia';
import titleBar from '@/components/titleBar';
import eleTab from '@/components/eleTab';
import layout from '@/components/layout';
export default {
  name: 'App',
  components: {
    eleHead,
    eleMenu,
    showMongolia,
    titleBar,
    eleTab,
    layout
  },
  data () {
    return {
      isRouterAlive: true,
      showProgress: false,
      timer: null,
      menuStatus: ''
    };
  },
  provide () {
    return {
      reload: this.reload
    };
  },
  created () {
    // 在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem('store')) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem('store'))
        )
      );
    }
    // 在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener('beforeunload', () => {
      if (this.$route.name !== 'login') {
        sessionStorage.setItem('store', JSON.stringify(this.$store.state));
      }
    });
    // 以上作用：防止页面刷新丢失vuex数据
    bus.$on('backLoading', (msg) => {
      this.showProgress = true;
    });
    bus.$on('backLoadEnd', (msg) => {
      this.showProgress = false;
    });
    bus.$on('login-overdue', (msg) => {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        if (this.$route.name !== 'login') {
          this.$router.push({
            name: 'login'
          });
          this.$message({
            type: 'warning',
            message: '登录已过期，请重新登录'
          });
        }
      }, 300);
    });
    bus.$on('error-message', (msg) => {
      this.$message({
        type: 'warning',
        message: msg
      });
    });
  },
  methods: {
    reload () {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    // 操控菜单收缩状态
    controlMenu (status) {
      this.menuStatus = status;
    }
  }
};
</script>

<style lang="less">
#app {
  width: 100%;
  height: 100vh;
}
.layout {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #f0f0f2;
  display: flex;
}

.mainLeft {
  box-sizing: border-box;
  height: 100%;
  box-shadow: 0 0 9px 2px rgba(220, 221, 224, 0.53);
}

.mainRight {
  width: 100%;
  height: 100%;
  background: #f5f7ff;
  overflow: auto;

  // & > div:nth-child(2) {
  //   width: 100%;
  //   height: calc(100vh - 100px);
  //   overflow: auto;
  // }

  & > div:nth-child(2) > div {
    margin: 16px;
  }
}

.vague {
  filter: blur(5px);
}
</style>



// WEBPACK FOOTER //
// src/App.vue